<template>
  <modal
    width="39"
    :show-modal="showModal"
    @close-modal="$emit('close-modal', id)"
  >
    <div class="mx-auto" style="width: 404px">
      <div class="my-3">
        <span class=""
          >Uplaod Document <tool-tip text="drag and drop"></tool-tip
        ></span>
      </div>

      <div
        class="flex p-16 justify-center rounded text-center mx-auto"
        style="
          width: 404px;
          height: 312px;
          border: 1px dashed #667499;
          background: #f0f4fe;
        "
      >
        <div class="my-auto mx-auto">
          <div
            :class="[previewImage ? 'imagePreviewWrapper' : '']"
            :style="{
              'background-image': previewImage
                ? `url(${previewImage})`
                : imageUrl.length > 0
                ? `url(${imageUrl})`
                : '',
            }"
            @click="selectImage"
          >
            <span class=" " v-if="!previewImage">
              Drag and drop files here of browse your device files:
            </span>

            <div
              v-if="!previewImage"
              class="mx-auto my-4 w-16 h-16 rounded"
              style="background: #667499"
            >
              <img
                class="p-4"
                src="@/assets/images/icons/coolicon.svg"
                alt=""
              />
            </div>
          </div>
          <div
            v-if="isUploadingImage"
            class="d-flex justify-content-center py-2"
          >
            <saving-loader :icon-color="'#0253B3'" />
          </div>
          <div>
            <base-button
              v-if="previewImage"
              text="Remove Picture"
              @click="removeImage"
              background="transparent"
            ></base-button>
            <base-button
              text="Browse Files"
              @click="$refs.fileInput.click()"
              background="transparent"
            ></base-button>
          </div>
        </div>
      </div>
      <div class="my-5 flex justify-start">
        <span>Supported File Type: .png, .jpg, pdf</span>
      </div>
      <input
        ref="fileInput"
        type="file"
        @input="pickFile"
        accept="image/*"
        class="file-input"
      />
      <hr class="border-dashed my-5" />
      <div>
        <base-button
          class=""
          :loading="loading"
          @click="uploadDocument"
          text="Cancel"
          background="white"
        />
        <base-button
          class="float-right"
          :loading="loading"
          @click="uploadDocument"
          text="Upload"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SavingLoader from "@/components/UI/ButtonSavingLoader";

export default {
  components: {
    SavingLoader,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    shipping: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      id: "cancel",
      docUrl: "",
      loading: false,
      previewImage: null,
      imageUrl: "",
      isUploadingImage: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal", this.id);
      this.$emit("close-modal");
    },

    async uploadDocument() {
      try {
        await this.$_updateShipping( this.shipping.id, this.docUrl);
        this.loading = false;
        this.$emit("close-modal");
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage() {
      this.previewImage = null;
      // this.$emit("remove-image");
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0].size > 1048576) {
        this.generateToast(
          "Selected image size is too large. Please upload an image smaller than 1MB!",
          "error"
        );
      } else {
        if (file && file[0]) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(file[0]);
          this.handleImageUpload(file[0]);
        }
      }
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.docUrl = response;

        console.log("imageurl", response);
        this.generateToast("Image uploaded", "success");
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
  },
  // mounted(){
  //   this.$on("booking-subaction-completed", () =>{
  //     alert("cancl modal")
  //     this.$emit("booking-subaction-completed");
  //   })
  // }
};
</script>

<style scoped>
.upload {
  border: 1px solid #80808063;
  color: #80808063;
  width: 100%;
  /* Full width */
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  border-radius: 10px;
}

.upload-icon {
  background: #fcc21382;
  padding: 1rem;
  justify-content: center;
  border-radius: 50%;
}
.file-input {
  display: none;
}
.imagePreviewWrapper {
  background-repeat: no-repeat;
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: block;
  cursor: pointer;
  background-image: url("/assets/images/settings/blank-profile-picture.png");
  margin: 0 auto;
  background-size: cover;
  background-position: center center;
}
</style>
